export const downloadAndGeneratePdf = (
  urlToDownload: string,
  onSuccess?: (successUrl: string) => void,
  onError?: () => void
) => {
  const xhr = new XMLHttpRequest();

  xhr.open("GET", urlToDownload);
  xhr.responseType = "blob";
  xhr.onload = () => {
    if (xhr?.status === 200 && xhr?.response) {
      const { response } = xhr;

      const blob = new Blob([response], { type: "application/pdf" });

      const urlToView = URL.createObjectURL(blob);

      window.open(`${urlToView}`, "_blank")?.focus();

      if (onSuccess) onSuccess(urlToView);
    }
  };
  xhr.onerror = () => {
    if (onError) onError();
  };
  xhr.send();
};
